import React, { ReactElement } from 'react';
import { Text } from 'idsk-react-components';
import NavrhAktuEuListPage from '../../../model/NavrhAktuEuListPage';
import NavrhAktuEuListRow from './NavrhAktuEuListRow';
import './navrhAktuEuListComponent.scss';

interface Props {
  aktEuPage: NavrhAktuEuListPage;
  isSelectedFilter: boolean;
}

const NavrhAktuEuListComponent = ({
  aktEuPage,
  isSelectedFilter,
}: Props): ReactElement => {
  if (aktEuPage.totalElements === 0 && isSelectedFilter) {
    return (
      <Text type="p" size="l" className="text-center">Nenašli sa žiadne akty zodpovedajúce zvolenému filtru.</Text>
    );
  }

  if (aktEuPage.totalElements === 0) {
    return <Text type="p" size="l" className="text-center">Neexistujú žiadne akty.</Text>;
  }

  if (aktEuPage.totalElements > 0 && aktEuPage.aktEuList.length === 0) {
    return (
      <Text type="p" size="l" className="text-center">
        Na aktuálnej stránke sa nenachádzajú žiadne akty.
      </Text>
    );
  }

  return (
    <>
      {aktEuPage.aktEuList.map((aktEu) => (
        <NavrhAktuEuListRow aktEu={aktEu} key={aktEu.uuid} />
      ))}
    </>
  );
};

export default NavrhAktuEuListComponent;
